<script setup>
import { markRaw } from 'vue'
import ComexDrilldownLayout from '@/components/base/fluxo/ComexDrilldownLayout.vue'
import ContratoCompraForm from '@/components/Compras/contratosCompra/ContratoCompraForm.vue'
import PurchaseOrderForm from '@/components/Compras/purchaseOrders/PurchaseOrderForm.vue'
import { useActiveScreen } from '@/composables/useActiveScreen'

defineProps({
  itemParaEditar: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['item-atualizado', 'cancelar', 'show-notification', 'changesDetected'])

// Registra o formulário real para o resolvedor de tela ativa
// O ContratoCompraCadastro sempre exibe ContratoCompraForm como primeiro estágio.
// Quando navega para PurchaseOrderForm via drilldown, o próprio PurchaseOrderForm
// já registra seu próprio activeForm via seu próprio orquestrador.
const { setActiveForm } = useActiveScreen()
setActiveForm('ContratoCompraForm')

const componentMap = {
  contrato: {
    component: markRaw(ContratoCompraForm),
    color: 'var(--bs-primary)',
    icon: 'bi-file-earmark-text',
    title: 'Contrato'
  },
  purchaseOrder: {
    component: markRaw(PurchaseOrderForm),
    color: 'var(--bs-info)',
    icon: 'bi-cart-check',
    title: 'Purchase Order'
  }
}

const pipelineStages = [
  { key: 'contrato', label: 'Contrato', icon: 'bi-file-earmark-text', color: 'var(--bs-primary)' },
  { key: 'purchaseOrder', label: 'Purchase Orders', icon: 'bi-cart-check', color: 'var(--bs-info)' }
]
</script>

<template>
  <ComexDrilldownLayout
    root-type="contrato"
    :root-item="itemParaEditar"
    :component-map="componentMap"
    :stages="pipelineStages"
    @item-atualizado="(item) => emit('item-atualizado', item)"
    @cancelar="emit('cancelar')"
    @show-notification="(notif) => emit('show-notification', notif)"
    @changes-detected="(v) => emit('changesDetected', v)"
  />
</template>
